// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import { getTags } from "../../actions/faceActions";
import {
  fetchPeople,
  deletePerson,
  updatePerson,
  getEnrolments
} from "../../actions/peopleActions";
import PeopleDrawerLayout from "../../components/people/PeopleDrawerLayout";
import ChipInput from "../../../global/components/ChipInput";

type PeopleDrawerPropsType = {
  db: { [key: string]: * },
  faceSearch: { [key: string]: * },
  actions: { [key: string]: Function }
};

class PeopleDrawer extends Component<PeopleDrawerPropsType, *> {
  addTags = (person: *) => {
    this.props.actions.updatePerson(person);
  };
  render(): * {
    return (
      <PeopleDrawerLayout
        tags={this.props.db.tagList}
        people={this.props.db.people}
        updating={this.props.db.updating}
        showMore={this.props.db.showMore}
        searchQuery={this.props.db.searchQuery}
        fetchPeople={this.props.actions.fetchPeople}
        deletePerson={this.props.actions.deletePerson}
        getTags={this.props.actions.getTags}
        addTags={this.addTags}
        getEnrolments={this.props.actions.getEnrolments}
        ChipInput={ChipInput}
      />
    );
  }
}

const mapStateToProps = (state: StateType): * => ({
  db: state.v3account.db,
  faceSearch: state.v3account.faceSearch
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators(
    {
      fetchPeople,
      deletePerson,
      getTags,
      getEnrolments,
      updatePerson
    },
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(PeopleDrawer);
